export default __webpack_public_path__ + "static/media/google-logo.87caff68.svg";